<template>
  <footer class="footer">
    <div class="footer__links footer__links--start">
      <a
        v-for="link in links"
        :key="link.title"
        :href="link.href"
        :target="link.target"
        class="footer__link"
        @click="link.handler($event) || (() => {})"
      >
        {{ $t(link.title) }}
      </a>
    </div>

    <div class="footer__links footer__links--end">
      <div class="footer__text">
        {{ copyRight }}
      </div>
    </div>
  </footer>
</template>

<script>
import moment from 'moment-jalaali';

import lang from '@/mixins/lang';
import { openAdsNewsletterModal } from '../advertisement/common/ads-newsletter';

export default {
  name: 'Footer',
  mixins: [lang],
  computed: {
    copyRight() {
      const m = moment();
      const year = this.lang === 'fa' ? m.format('jYYYY') : m.format('YYYY');
      return this.$t('SITE_COPYRIGHT', { year });
    },
    links() {
      return [
        {
          title: this.$t('BAZAAR'),
          href: 'https://cafebazaar.ir/',
          target: '_blank',
        },
        {
          title: this.$t('DOCUMENTATION'),
          href: 'http://developers.cafebazaar.ir/',
          target: '_blank',
        },
        {
          title: this.$t('BLOG'),
          href: 'https://developers.cafebazaar.ir/fa/blog',
          target: '_blank',
        },
        {
          title: this.$t('PUBLISH_RULES'),
          href: 'https://developers.cafebazaar.ir/fa/app-publish-guidelines/',
          target: '_blank',
        },
        {
          title: this.$t('ADS_ACADEMY'),
          href: 'https://ads.cafebazaar.ir/academy',
          target: '_blank',
        },
        {
          title: this.$t('SUBSCRIBE_TO_NEWSLETTER'),
          handler: event => {
            event.preventDefault();
            openAdsNewsletterModal.call(this);
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss">
$off-canvas-width: 220px !default;

.footer {
  display: flex;
  margin-top: 1.5 * $global-margin;

  font-size: 0.875rem;
  font-weight: 300;

  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  @each $breakpoint, $value in $grid-column-gutter {
    $padding: rem-calc($value) / 2;

    @include breakpoint($breakpoint) {
      padding-left: $padding;
      padding-right: $padding;
    }
  }

  @include breakpoint(medium) {
    margin-top: $global-margin;
    padding-top: 1.5 * $global-padding;
    padding-bottom: 1.5 * $global-padding;

    flex-direction: row;
  }

  &__links {
    display: flex;
    padding-top: $global-padding / 2;
    padding-bottom: $global-padding / 2;

    flex-wrap: wrap;

    &--start {
      align-items: flex-start;
    }

    &--end {
      align-items: flex-end;
    }
  }

  &__text {
    color: lighten($asbestos, 15%);
    cursor: default;
  }

  &__link {
    padding: $global-padding / 2;
    flex: 1 40%;

    text-align: center;
    color: $asbestos;

    &:hover {
      color: $lb-color-primary;
    }

    @include breakpoint(medium) {
      padding: 0;
      flex: 0 auto;

      &:not(:only-child) {
        margin-left: 1rem;
        margin-right: 1rem;
      }

      &:first-child {
        margin-left: auto;

        @include rtl() {
          margin-left: 1rem;
          margin-right: auto;
        }
      }

      &:last-child {
        margin-right: auto;

        @include rtl() {
          margin-right: 1rem;
          margin-left: auto;
        }
      }
    }
    // end breakpoint
  }
}
</style>
